export default __webpack_public_path__ + "static/media/peter_cui.e6d28c9b.jpg";